Number.prototype.formatMoney = function(decPlaces, thouSeparator, decSeparator) {
    var n = this,
        decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSeparator = decSeparator == undefined ? "." : decSeparator,
        thouSeparator = thouSeparator == undefined ? "," : thouSeparator,
        sign = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(decPlaces)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return sign + (j ? i.substr(0, j) + thouSeparator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thouSeparator) + (decPlaces ? decSeparator + Math.abs(n - i).toFixed(decPlaces).slice(2) : "");
};

function updateUserBalance() {
    $.post('/user/getBalance', {}, function(response) {
        $('#user-balance-text').html(response.balance);
        $('#user-hold-balance-text').html(response.holdBalance);
    }, 'json');
}

function socialPost(postData, service) {
    var host = window.location.hostname;
    if (postData.image && postData.image.indexOf(host) == -1) {
        postData.image = 'https://' + window.location.hostname + postData.image;
    }
    if (service === undefined) service = window.userService;
    switch (service) {
        case 'facebook':
            Share.fb(postData);
            // socialPostFB(postData);
            break;
        case 'vkontakte':
            Share.vk(postData);
            // socialPostVK(postData);
            break;
        // case 'twitter':
        //     socialPostTW(postData);
        //     break;
        // case 'mailru':
        //     socialPostMR(postData);
        //     break;
        case 'odnoklassniki':
            Share.ok(postData);
            // socialPostOK(postData);
            break;
    }
}

// function setSocialButton($modal, postData, service) {
//     if (service === undefined) service = window.userService;
//     switch (service) {
//         case 'facebook':
//             setSocialButtonFB($modal, postData);
//             break;
//         case 'vkontakte':
//             setSocialButtonVK($modal, postData);
//             break;
//         case 'twitter':
//             setSocialButtonTW($modal, postData);
//             break;
//         case 'mailru':
//             setSocialButtonMR($modal, postData);
//             break;
//         case 'odnoklassniki':
//             setSocialButtonOK($modal, postData);
//             break;
//     }
// }


function reachGoal(goal) {
    if (window.APP_ENV == 'debug') {
        return;
    }

    if (window.yaCounter26657601 === undefined) {
        setTimeout(function() {
            reachGoal(goal);
        }, 300);
        return false;
    }

    var goals = goal.split(',');
    $(goals).each(function() {
        //console.log('Reach goal: ' + goal);
        yaCounter26657601.reachGoal(this);
    });
}

function serverReachGoal(goal, tour_id) {
    $.post('/logger/reachGoal', {
        goal: goal,
        model_id: tour_id
    }, function(response) {
        if (response.status && response.status == 'success') {} else {}
    }, 'json');
}

var maxBets = 5,
    shareBet = shareBet || false;

/// Hack for windowLocation with Referer
function navigateToUrl(url, params) {
    var f = document.createElement("FORM");
    f.action = url;
    f.method = 'get';
    if (params) {
        for (key in params) {
            var input = document.createElement("INPUT");
            input.type = "hidden";
            input.name = key;
            input.value = params[key];
            f.appendChild(input);
        }
    }
    document.body.appendChild(f);
    f.submit();
}

function successBid(id) {
    $.ajax({
        url: '/tourObject/markPosted/' + id,
        type: 'post',
        success: function() {
            swal({
                    title: "Спасибо!",
                    text: 'Приятного вам отдыха!',
                    type: "success",
                    confirmButtonColor: "#2A8FBD",
                    confirmButtonText: "Ок",
                    closeOnConfirm: false
                },
                function(isConfirm) {
                    if (isConfirm) {
                        window.location = '/user/account?show=won';
                    }
                });
        }
    });
}

// function sendBetForm($form, forcebet) {
//     var data = JSON.parse('{"' + decodeURI($form.serialize()).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
//     var tour_id = data.tour_id;
//
//     if (forcebet !== undefined) {
//         //data.number = forcebet;
//         data.amount = forcebet;
//     }
//     $.ajax({
//         url: $form.attr('action'),
//         type: $form.attr('method'),
//         data: data,
//
//         success: function(response) {
//             if (response.success) {
//                 if (response.blitz) {
//                     $('#bets-remain').html('');
//
//                     //          $('.current-price-container .price').html(response.current_price + '<i class="fa fa-rub"></i>');
//                     swal({
//                             title: "Поздравляем!",
//                             text: 'Вы выиграли торги за лот!',
//                             type: "success",
//                             allowHTML: true,
//                             showCancelButton: false,
//                             confirmButtonColor: "#2A8FBD",
//                             confirmButtonText: "Перейти к оплате",
//                             cancelButtonText: 'Закрыть',
//                             closeOnConfirm: false
//                         },
//                         function(isConfirm) {
//                             if (isConfirm) {
//                                 window.location.href = '/reservation/index?tour_id=' + tour_id;
//                             } else {
//                                 if (response.isUserActive) {
//                                     showCongratulationForActive();
//                                 }
//                                 refreshSideBar($('#tour-sidebar').data('tour-id'));
//                             }
//                         });
//                 } else {
//
//                     var isNeedPost = $form.data('need-post');
//
//                     $form.data('need-post', 0);
//                     var remainBets = response.remainBets;
//                     var betsRemainText = 'Осталось ' + remainBets + ' ' + Text.plural(remainBets, ['ставка', 'ставки', 'ставок']);
//                     $('#bets-remain').html(betsRemainText);
//
//                     var title = "Ставка принята";
//                     var text = 'Поздравляем, вы лидируете!';
//
//                     if (response.ceytnot) {
//                         title = 'Ставка принята';
//                         text = 'Ставка сделана менее чем за 5 минут<br>до окончания торгов.<br/>Торги продлены на 5 минут.';
//                     }
//
//                     if (isNeedPost) {
//                         serverReachGoal('social_post_complete', $('#tour-sidebar').data('tour-id'));
//                     }
//
//                     if (parseInt(response.current_price.replace(' ', '')) > 500) {
//                         reachGoal('bet_500');
//                     }
//
//                     //          $('.current-price-container .price').html(response.current_price + '<i class="fa fa-rub"></i>');
//                     swal({
//                             title: title,
//                             text: text,
//                             allowHTML: true,
//                             type: "success",
//                             confirmButtonColor: "#2A8FBD",
//                             confirmButtonText: "Ок",
//                             closeOnConfirm: true
//                         },
//                         function(isConfirm) {
//                             if (isConfirm) {
//                                 if (response.isUserActive) {
//                                     showCongratulationForActive();
//                                 }
//                                 refreshSideBar($('#tour-sidebar').data('tour-id'));
//                                 //window.location.reload();
//                             }
//                         });
//                 }
//
//                 updateUserBalance();
//             } else {
//                 $(".shareButton").remove();
//                 var title = 'Ставка не принята.';
//                 if (response.error_code == 'current_price') {
//                     title = 'Ставка не может быть ниже текущей цены.';
//                 }
//
//                 swal({
//                         title: title,
//                         text: response.error_message,
//                         type: "error",
//                         confirmButtonColor: "#2A8FBD",
//                         confirmButtonText: "Ок",
//                         closeOnConfirm: true
//                     },
//                     function(isConfirm) {
//                         if (response.error_code == 'auction_finished' || response.error_code == 'current_price') {
//                             refreshSideBar($('#tour-sidebar').data('tour-id'));
//                         }
//                     }
//                 );
//             }
//         }
//     });
// }

var buttonTexts = [];

function setButtonLoading($button, state) {
    if (!$button.data('originalHTML')) {
        $button.data('originalHTML', $button.html());
    }

    if (state) {
        $button.html('<i class="fa fa-spinner fa-spin"></i> Загрузка').attr('disabled', true);
    } else {
        $button.html($button.data('originalHTML')).attr('disabled', false);
    }
}


function showWelcomeModal() {
    //if ($('#welcome-modal').length > 0) {
    //  $('#welcome-modal').modal('show');
    //}
}

function showFollowModal() {
    var $followModal = $('#follow-modal');
    if ($followModal.length > 0) {
        $followModal.modal('show');
    }
}

function cleanErrors($container) {
    $container.find('.help-block').remove();
    $container.find('.form-group').removeClass('has-error');
}

function showErrors($container, errors) {
    for (var elementId in errors) {
        var element = $container.find('#' + elementId);
        if (element.length == 0) {
            element = $container.find('#yt' + elementId);
        }

        element.closest('.form-group').addClass('has-error');

        errors[elementId].forEach(function(item) {
            element.closest('.form-group').find('.col-sm-8').append($('<span />').addClass('help-block').css('display', 'block').text(item));
        });
    }
}

// function showLimitModal() {
//     if ($('#limit-modal').length > 0) {
//         cleanErrors($('#limit-modal'));
//         $('#limit-modal').modal('show');
//     }
// }

function showCongratulationForActive() {
    //var timer = setTimeout(function(){
    //  clearTimeout(timer);
    //
    //  swal({
    //    title: "Поздравляем!",
    //    text: 'Вы проявляете активность, поэтому мы даем Вам возможность использователь функционал автоставок',
    //    type: "success",
    //    showCancelButton: false,
    //    confirmButtonColor: "#2A8FBD",
    //    confirmButtonText: "Ок",
    //    closeOnConfirm: true
    //  }, function(isConfirm){
    //    if (isConfirm) {
    //      location.reload();
    //    }
    //  });
    //}, 300);
}

function initSocialGroups(map, callback) {
    var getType = {};
    if ($('#'+map.ok.id).length > 0 && typeof(OK) != 'undefined' && OK != null) {
        OK.CONNECT.insertGroupWidget(map.ok.id, map.ok.groupId, map.ok.options);

        // Вызовем callback после небольшой задержки. У ok нет поддержки callback
        if (callback && getType.toString.call(callback) === '[object Function]') {
            setTimeout(function () {
                callback();
            }, 300);
        }
    }

    if ($('#'+map.vk.id).length > 0 && typeof(VK) != 'undefined' && VK != null) {
        VK.Widgets.Group(map.vk.id, map.vk.options, map.vk.groupId);

        // Вызовем callback после небольшой задержки. У вк нет поддержки callback
        if (callback && getType.toString.call(callback) === '[object Function]') {
            setTimeout(function () {
                callback();
            }, 300);
        }
    }

    if ($('#'+map.fb.id).length > 0 && typeof(FB) != 'undefined' && FB != null) {
        var $parent = $('#'+map.fb.id).parent();
        $('#'+map.fb.id).html('').attr('data-width', $parent.width());
        FB.XFBML.parse(null, callback);
    }
};

var
    isMobileBrowser = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));

$(function() {
    // Определяем что страница открыта в iFrame
    if (window != window.top) {
        $.post('/site/fromIframe');
    }

    //  // вот это сейчас будет костылище!
    //// редиректим на мобильные комменты
    //
    //  var currentLocation = window.location.href,
    //    domain,
    //    tourId,
    //    commentId,
    //    match;
    //  match = currentLocation.match(/http:\/\/turbazar\.(dev|ru)\/tourObject\/(\d+)\#comment_(\d+)/);
    //  if (match && isMobileBrowser) {
    //    domain = match[1];
    //    tourId = match[2];
    //    commentId = match[3];
    //    alert('redirect to ' + 'http://turbazar.'+domain+'/fullDescription/'+tourId+'/#comment_'+commentId);
    //    window.location = 'http://turbazar.'+domain+'/fullDescription/'+tourId+'/#comment_'+commentId;
    //  }


    // owlSliderPagination = owlCarouselSlider.attr('data-pagination');

    if (isMobileBrowser) {
        FastClick.attach(document.body);
    }

    //  $('.popup-image').magnificPopup({
    //    type: 'image',
    //    gallery: {
    //      enabled: true
    //    }
    //  });

    $('.select').selectpicker({
        size: 10
    });

    $('.gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a.popup-image', // the selector for gallery item
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });

    $('.comment-content a').each(function() {
        var href = $(this).attr('href');
        var matchYoutube = href.match(/^.+youtube.com\/watch\?v=([^&]+)/);
        if (matchYoutube !== null && matchYoutube[1] !== undefined) {
            $(this).magnificPopup({
                type: 'iframe',
                iframe: {
                    patterns: {
                        dailymotion: {

                            index: 'youtube.com',

                            id: function(url) {
                                var m = url.match(/^.+youtube.com\/watch\?v=([^&]+)/);
                                if (m !== null && m[1] !== undefined) {
                                    return m[1];
                                }
                                return null;
                            },

                            src: '//www.youtube.com/embed/%id%?autoplay=1'

                        }
                    }
                }
            });
        }
    });

    // Lighbox gallery
    $('#popup-gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a.popup-gallery-image',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });

    // Checkboxes and radio
    $('.i-check, .i-radio').iCheck({
        checkboxClass: 'i-check',
        radioClass: 'i-radio'
    });

    // footer always on bottom
    var docHeight = $(window).height();
    var footerHeight = $('#main-footer').height();
    var footerTop = $('#main-footer').position().top + footerHeight;

    if (footerTop < docHeight) {
        $('#main-footer').css('margin-top', (docHeight - footerTop) + 'px');
    }

    $('body').tooltip({
        selector: '[rel=tooltip]'
    });

    $('body').popover({
        selector: '[rel=popover]',
        trigger: "hover"
    });

    if (!isMobileBrowser) {
        $(".phoneMask").inputmask("+7 (999) 999-99-99");
        $(".codeMask").inputmask("9999");
    }

    //Show On Map
    $(".show-on-map-button").click(function(e) {
        e.preventDefault();
        var selector = $(this).attr('href');
        $(selector).toggleClass('open');
        if ($(selector).hasClass('open')) {
            $(this).text('Скрыть карту');
        } else {
            $(this).text('Показать на карте');
        }

        //if(mapsbyId['catalogMap'] && typeof mapsbyId['catalogMap'].container != 'undefined') {
        //  mapsbyId['catalogMap'].container.fitToViewport();
        //}

        return false;
    });

    $('body').on('click', '.load-more-button', function(e) {
        e.preventDefault();
        var self = this;
        $.ajax({
            url: $(self).attr('href'),
            success: function(response) {
                var items = response.items,
                    pagination = response.pagination;

                var clearedResponse = $(items).unwrap().html();
                $('.tour-cards').append(clearedResponse);

                $('.load-more-button-container').replaceWith(pagination);
            }
        });
    });

    if ($('.countdown').length > 0) {
        var startTime;
        $.ajax({
            url: '/site/serverTime',
            dataType: 'json',
            beforeSend: function() {
//                d = new Date();
//                startTime = d.getTime();
                startTime = new Date();
            },
            success: function(data) {
//                d = new Date();
//                const serverTime = Date.parse(data.datetime);
//                const elapsedTime = d.getTime() - startTime;

                //console.log('Elapsed: ' + elapsedTime);
                //console.log('From server: ' + data.datetime);

//                const countdownTime = serverTime + elapsedTime;
//                var countdownDate = new Date(countdownTime);

                //console.warn('Before: ' + data.datetime);
                //console.warn('After: ' + countdownDate.toString());

                initCountdown(data.datetime, startTime);
            }
        });
    }

    if ($('.price-countdown').length > 0) {
        if ($('#tour-sidebar').length > 0) {
            $.ajax({
                url: '/tourObject/blitzPrice/' + $('.price-countdown').data('tour-id'),
                dataType: 'json',
                success: function(data) {
                    initPriceContdown(data.serverTime, data.blitz_price);
                }
            });
        } else {
            $.ajax({
                url: '/site/serverTime/',
                dataType: 'json',
                success: function(data) {
                    initPriceContdown(data.serverTime, false);
                }
            });
        }
    }

    var $loginModal = $('#login-modal');

    $loginModal.on('click', '.newbie-button', function(e) {
        e.preventDefault();
        $('#newbie-modal').modal('show');
    });

    $loginModal.on('click', '.exist-user-button', function(e) {
        e.preventDefault();
        $('#exist-user-modal').modal('show');
    });

    $('body').on('click', 'a.scroll-to', function() {
        var id = $(this).attr('href');
        $('body').stop().scrollTo(id, 800);
    });


    //var $productMeta = $('.product-page-meta');
    //if ($productMeta.length > 0 && !isMobileBrowser) {
    //  var topOffset = $productMeta.offset().top - 20;
    //
    //  $productMeta.affix({
    //    offset: {
    //      top: topOffset,
    //      bottom: 370
    //    }
    //  });
    //}

    if ($('#tour-sidebar').length > 0) {
        var tourId = $('#tour-sidebar').data('tour-id');
        startSideBarTimer(tourId);
    }

    function checkNeedPhoneValidation(tour_id, user_id, callback) {
        $.post('/tourObject/isNeedPhoneValidation?tour_id=' + tour_id + '&user_id=' + user_id, {}, function(response) {

            if (response.needValidation) {
                var $modal = $('#user-validate-phone-modal');
                $modal.off("click", "**");

                validationPhoneFirstStep($modal, response.phone);

                if (response.needPhone) {
                    $modal.on('click', '.phone-validation-button', function(e) {
                        e.preventDefault();

                        var $phone = $('#validationPhone');
                        unmarkErrorField($phone);

                        $.post('/tourObject/validateUserPhone', {
                            phone: $phone.val()
                        }, function(response) {
                            if (response.status) {
                                validationPhoneSecondStep(e, $modal);
                            } else {
                                markErrorField($phone, response.message);
                            }
                        }, 'json');
                    });
                } else {
                    var e = jQuery.Event('click');
                    validationPhoneSecondStep(e, $modal);
                }

                $modal.on('click', '.phone-validation-activate-button', function(e) {
                    var $code = $('#validationPhoneCode');
                    unmarkErrorField($code);

                    $.post('/tourObject/activateUserPhone', {
                        code: $code.val()
                    }, function(response) {
                        if (response.status) {
                            validationPhoneThirdStep(e, $modal);
                        } else {
                            markErrorField($code, response.message);
                        }
                    }, 'json');
                });

                $modal.on('click', '.phone-validation-finish-button', function(e) {
                    e.preventDefault();
                    $modal.modal('hide');
                    callback();
                });

                $modal.modal('show');
            } else {
                callback();
            }
        }, 'json');
    }

    function unmarkErrorField($field) {
        $field.removeClass('error');
        $field.closest('.form-group').find('.errorMessage').html('');
    }

    function markErrorField($field, message) {

        $field.addClass('error');
        $field.closest('.form-group').find('.errorMessage').html(message);
    }

    function validationPhoneFirstStep($modal, phone) {

        $modal.find('.phoneMask').val(phone);
        if (!isMobileBrowser) {
            $modal.find('.phoneMask').inputmask("+7 (999) 999-99-99");
        }

        $modal.find('.first-step').removeClass('hide');
        $modal.find('.second-step').removeClass('hide').addClass('hide');
        $modal.find('.third-step').removeClass('hide').addClass('hide');
    }

    function validationPhoneSecondStep(e, $modal) {
        e.preventDefault();

        unmarkErrorField($modal.find('.codeMask'));
        $modal.find('.codeMask').val('');
        $modal.find('.codeMask').inputmask("9999");

        $modal.find('.first-step').removeClass('hide').addClass('hide');
        $modal.find('.second-step').removeClass('hide');
        $modal.find('.third-step').removeClass('hide').addClass('hide');
    }

    function validationPhoneThirdStep(e, $modal) {
        e.preventDefault();

        $modal.find('.first-step').removeClass('hide').addClass('hide');
        $modal.find('.second-step').removeClass('hide').addClass('hide');
        $modal.find('.third-step').removeClass('hide');
    }

    // function askBet($form, needPost, postData) {
    //
    //     var isBlitz = !$form.hasClass('make-bet-form');
    //     var text = '',
    //         title = '',
    //         confitmButtonText = '';
    //
    //     if (isBlitz) {
    //         //title = "Подтвердите ставку: " + postData.bet + " руб.";
    //         title = 'Подтвердите ставку «блиц-цена»: ' + postData.bet + ' рублей';
    //     } else {
    //         title = "Получите доступ к торгам";
    //         //title = "Вы уверены что хотите сделать ставку "+postData.bet +" рублей?";
    //     }
    //
    //     if (needPost) {
    //         confitmButtonText = 'Сделать пост';
    //
    //         if (isBlitz) {
    //             text = 'Это мгновенная победа!<br>По правилам аукциона нужно разместить пост о победе в соцсети, чтобы получить доступ к оплате.';
    //         } else {
    //             text = 'По правилам аукциона нужно рассказать о лоте в соцсети, чтобы начать торги. Пост публикуется только при первой ставке.';
    //         }
    //     } else {
    //         confitmButtonText = 'Да, подтверждаю';
    //
    //         if (isBlitz) {
    //
    //         } else {
    //             title = "Подтвердите ставку: " + postData.bet + " руб.";
    //         }
    //     }
    //
    //     $(".shareButton").remove();
    //
    //     clearTimeout(betPopup);
    //     var betPopup = setTimeout(function() {
    //         swal({
    //                 title: title,
    //                 text: text,
    //                 type: "warning",
    //                 showCancelButton: true,
    //                 confirmButtonColor: "#2A8FBD",
    //                 confirmButtonText: confitmButtonText,
    //                 cancelButtonText: "Отмена",
    //                 closeOnConfirm: true,
    //                 closeOnCancel: true,
    //                 allowHTML: true,
    //                 afterShow: function($dom) {
    //                     if (needPost) setSocialButton($dom, postData);
    //                 }
    //             },
    //             function(isConfirm) {
    //                 if (isConfirm) {
    //                     if (needPost) {
    //                         reachGoal('click_post');
    //                         serverReachGoal('click_social_post_btn', postData.tour_id);
    //
    //                         socialPost(postData);
    //                         // check for social post
    //                     } else {
    //                         sendBetForm($form, postData.bet);
    //                     }
    //                 }
    //             }
    //         );
    //     }, 500);
    // }

    $('body').on('click', '.hide-tooltip', function(e) {
        e.preventDefault();

        var target = $(this).data('target');
        $(target).tooltip('destroy');

        return false;
    });

    // $('.make-bet-form, .buyout-form').on('submit', function(e) {
    //     e.preventDefault();
    //     var $form = $(this);
    //     var $button = $form.find('button');
    //
    //     var needPost = $form.data('need-post');
    //     var isBlitz = !$form.hasClass('make-bet-form');
    //     var share_type = (isBlitz) ? 'blitz' : 'bet';
    //     var blitz_price = parseInt($(".buyout-form").data('price'));
    //     var bet = (isBlitz) ? parseInt($form.data('price')) : $form.find('input[name=amount]').val();
    //     var message = (isBlitz) ? 'Купил по блиц' : 'Сделал ставку';
    //     var next_bet = parseInt($form.data('next-bet'));
    //
    //     if (blitz_price < bet) {
    //         $form.find('input[name=amount]').tooltip({
    //             title: 'Ставка не может быть больше блиц-цены' +
    //                 '<div class="text-right mt5 mb10"><a href="#" class="dashed hide-tooltip" data-target="#bet_amount">Скрыть</a></div>',
    //             html: true,
    //             trigger: 'manual'
    //         }).tooltip('show');
    //
    //
    //         return false;
    //     }
    //     if (next_bet > bet) {
    //         $form.find('input[name=amount]').tooltip({
    //             title: 'Ставка должна быть не&nbsp;меньше ' + next_bet + ' руб' +
    //                 '<div class="text-right mt5 mb10"><a href="#" class="dashed hide-tooltip" data-target="#bet_amount">Скрыть</a></div>',
    //             html: true,
    //             trigger: 'manual'
    //         }).tooltip('show');
    //         return false;
    //     }
    //     if ((bet == blitz_price) && (!isBlitz)) {
    //         $(".buyout-form").trigger('submit');
    //         return false;
    //     }
    //
    //     $.post('/tourObject/logTryMakeBet', {
    //         tour_id: $form.data('id')
    //     });
    //
    //     var needLogin = $form.data('need-login');
    //     if (needLogin) {
    //         reachGoal('button_bet');
    //         serverReachGoal('click_bet_btn_as_guest', $form.data('id'));
    //
    //         $('#login_link').trigger('click');
    //         $("#login-modal .btn").unbind().click(function() {
    //
    //             reachGoal('button_sn');
    //             serverReachGoal('click_social_auth_btn', $form.data('id'));
    //
    //             localStorage.setItem('tourID', $form.data('id'));
    //             localStorage.setItem('isBlitz', isBlitz);
    //             localStorage.setItem('betValue', bet);
    //         });
    //         initEauth();
    //         //alert(1);
    //         return false;
    //     }
    //
    //     var isLeader = $form.data('is-leader');
    //     if (isLeader) {
    //         setTimeout(function() {
    //             swal({
    //                 title: "Ставка не принята",
    //                 text: 'Вы являетесь лидером торгов.',
    //                 type: "error",
    //                 confirmButtonColor: "#2A8FBD",
    //                 confirmButtonText: "Закрыть",
    //                 closeOnConfirm: true
    //             });
    //         }, 100);
    //
    //         return false;
    //     }
    //
    //     //    var needConfirmEmail = $form.data('need-confirm-email');
    //     //
    //     //    if(needConfirmEmail){
    //     //      setTimeout(function(){
    //     //        swal({
    //     //            title: "Подтвержение Email",
    //     //            text: 'Письма, которые мы отправляем тебе не даходят, укажи новый Email чтобы делать ставки.',
    //     //            type: "error",
    //     //            showCancelButton: true,
    //     //            confirmButtonColor: "#2A8FBD",
    //     //            confirmButtonText: "Указать корректный Email",
    //     //            cancelButtonText: "Отмена"
    //     //          },
    //     //          function (isConfirm) {
    //     //            if(isConfirm){
    //     //              location.href = '/user/changeEmail';
    //     //            }
    //     //          }
    //     //        );
    //     //      }, 100);
    //     //      return false;
    //     //    }
    //
    //     var postData = {
    //         id: $form.data('id'),
    //         user_id: $form.data('user-id'),
    //         tour_id: $form.data('tour-id'),
    //         bet: bet,
    //         share_type: share_type,
    //         title: $form.data('title'),
    //         image: $form.data('image'),
    //         message: message,
    //         postID: null,
    //         description: $form.data('description'),
    //         success: function() {
    //             if (isBlitz) {
    //                 reachGoal('post_final');
    //             } else {
    //                 reachGoal('post_new');
    //             }
    //
    //             sendBetForm($form, postData.bet);
    //         },
    //         error: function() {
    //             $(".shareButton").remove();
    //             swal({
    //                     title: "Ставка не принята",
    //                     text: 'Чтобы все получилось, разместите пост о лоте в соцсети.',
    //                     type: "error",
    //                     confirmButtonColor: "#2A8FBD",
    //                     confirmButtonText: "Закрыть",
    //                     closeOnConfirm: true
    //                 },
    //                 function(isConfirm) {
    //                     refreshSideBar($('#tour-sidebar').data('tour-id'));
    //                 }
    //             );
    //         }
    //     };
    //
    //     if (postData.bet > 500) {
    //         reachGoal('zapros_bet_500');
    //     }
    //
    //     if (needPost) {
    //         setButtonLoading($button, true);
    //         $.ajax({
    //             url: '/tourObject/createUrl',
    //             data: {
    //                 json: true,
    //                 share_type: postData.share_type,
    //                 id: postData.id,
    //                 tour_id: postData.tour_id,
    //                 bet: postData.bet
    //             },
    //             dataType: 'json',
    //             success: function(post) {
    //                 setButtonLoading($button, false);
    //
    //                 $.extend(postData, post);
    //
    //                 if (postData.error == 1) {
    //                     swal({
    //                             title: "Ставка не принята",
    //                             text: postData.error_message,
    //                             type: "warning",
    //                             confirmButtonColor: "#2A8FBD",
    //                             confirmButtonText: "Закрыть",
    //                             closeOnConfirm: true
    //                         },
    //                         function(isConfirm) {
    //                             refreshSideBar($('#tour-sidebar').data('tour-id'));
    //                         }
    //                     );
    //                 } else {
    //                     checkBalance(postData.tour_id, postData.user_id, function() {
    //                         if (postData.bet > 500) {
    //                             reachGoal('balance_full');
    //
    //                         }
    //                         askBet($form, needPost, postData);
    //                     });
    //                 }
    //             },
    //             error: function(data) {
    //                 setButtonLoading($button, false);
    //                 // Не смогли сгенерировать url
    //                 $(".shareButton").remove();
    //                 swal({
    //                         title: "Ставка не принята",
    //                         text: 'Извините, произошла ошибка, попробуйте ещё раз',
    //                         type: "error",
    //                         confirmButtonColor: "#2A8FBD",
    //                         confirmButtonText: "Закрыть",
    //                         closeOnConfirm: true
    //                     },
    //                     function(isConfirm) {
    //                         refreshSideBar($('#tour-sidebar').data('tour-id'));
    //                     }
    //                 );
    //             }
    //         });
    //     } else {
    //         checkBalance(postData.tour_id, postData.user_id, function() {
    //             askBet($form, needPost, postData);
    //         });
    //     }
    //     // Генерим Url для шары
    // });
    //
    //
    // if (localStorage.getItem('tourID')) {
    //     var tourID = localStorage.getItem('tourID'),
    //         isBlitz = localStorage.getItem('isBlitz'),
    //         betValue = parseInt(localStorage.getItem('betValue')),
    //         currentTour = $(".make-bet-form").data('id');
    //
    //     if ($(".make-bet-form").data('need-login') == '0') {
    //         if (currentTour == tourID) {
    //             if (isBlitz == 'true') {
    //                 $(".buyout-form").trigger('submit');
    //             } else {
    //                 var currentValue = parseInt($("#bet_amount").val());
    //                 if (currentValue > betValue) {
    //                     setTimeout(function() {
    //                         swal({
    //                             title: 'Ошибка!',
    //                             text: 'Ставка должна быть больше текущей цены!',
    //                             type: "error",
    //                             confirmButtonColor: "#2A8FBD",
    //                             confirmButtonText: "Закрыть",
    //                             closeOnConfirm: true
    //                         });
    //                     }, 500);
    //                 } else {
    //                     $("#bet_amount").val(betValue);
    //                     $(".make-bet-form").trigger('submit');
    //                 }
    //             }
    //         }
    //     }
    // }
    // localStorage.removeItem('tourID');
    // localStorage.removeItem('isBlitz');
    // localStorage.removeItem('betValue');




    // function showSuccessModal(betType) {
    //     var tour_id = $('#tour_id').val();
    //
    //     if (betType == 'bet') {
    //         reachGoal('bet');
    //         setTimeout(function() {
    //             swal({
    //                 title: "Ставка принята",
    //                 text: 'Поздравляем, Вы лидируете!',
    //                 type: "success",
    //                 confirmButtonColor: "#2A8FBD",
    //                 confirmButtonText: "Ок",
    //                 closeOnConfirm: true
    //             });
    //         }, 500);
    //     } else {
    //         reachGoal('bet');
    //         setTimeout(function() {
    //             swal({
    //                     title: "Ставка принята",
    //                     text: 'Поздравляем!<br>Для завершения сделки необходимо оплатить лот',
    //                     type: "success",
    //                     confirmButtonColor: "#2A8FBD",
    //                     confirmButtonText: "Перейти к оплате",
    //                     closeOnConfirm: true,
    //                     allowHTML: true
    //                 },
    //                 function(isConfirm) {
    //                     if (isConfirm) {
    //                         window.location.href = '/reservation/index?tour_id=' + tour_id;
    //                     }
    //                 }
    //             );
    //         }, 500);
    //     }
    // }

    // $('.buyout-form').on('submit', function() {
    //     // post
    //     //sendBetForm($(this));
    // });

    $('div[data-tour-id]').on('click', '.load-more', function(e) {
        e.preventDefault();

        var link_title = $('.hidden_bet:hidden').length > 0 ? 'Показать меньше' : 'Показать все ставки';

        $(this).parents('table').find('.hidden_bet').toggle();
        $(this).html(link_title);
        return false;
    });

    //$("#mobile-nav").mmenu({
    //  slidingSubmenus: false,
    //  offCanvas: {
    //    "position": "right"
    //  }
    //},{
    //
    //});

    // $('.betLimit').on('click', function(e) {
    //     e.preventDefault();
    //     swal({
    //         title: $(this).parents('form').data('error-code'),
    //         text: $(this).parents('form').data('error-message'),
    //         type: "error",
    //         confirmButtonColor: "#2A8FBD",
    //         confirmButtonText: "Ок",
    //         closeOnConfirm: true
    //     });
    // });

    $('.betBtn').each(function() {
        if (!$(this).parents('form').hasClass('disabled')) {
            $(this).removeAttr('disabled');
        }
    });

    if ($('.pay-btn').length > 0) {
        $('.pay-btn').closest('form').submit();
    }

    // if ($("#finalShare").length) {
    //     var $form = $("#finalShare");
    //
    //     var postData = {
    //         url: $form.data('url'),
    //         title: $form.data('title'),
    //         description: $form.data('description'),
    //         image: $form.data('image'),
    //         message: $form.data('message'),
    //         price: $form.data('price'),
    //         postID: $form.data('postid'),
    //         success: function() {
    //             reachGoal('post_final');
    //             swal({
    //                     title: "Спасибо!",
    //                     text: 'Ваучер выслан и совсем скоро придет вам на почту. Приятного отдыха!',
    //                     type: "success",
    //                     confirmButtonColor: "#2A8FBD",
    //                     confirmButtonText: "Ок",
    //                     closeOnConfirm: false
    //                 },
    //                 function(isConfirm) {
    //                     if (isConfirm) {
    //                         window.location = '/reservation/finish?tour_id=' + $form.data('id');
    //                     }
    //                 });
    //         },
    //         error: function() {
    //             $(".shareButton").remove();
    //             swal({
    //                 title: "Что-то пошло не так",
    //                 text: 'Чтобы получить ваучер, вам нужно рассказать друзьям о своей победе!',
    //                 type: "error",
    //                 confirmButtonColor: "#2A8FBD",
    //                 confirmButtonText: "Закрыть",
    //                 closeOnConfirm: true
    //             });
    //         }
    //     };
    //     $form.submit(function() {
    //         var text = 'Чтобы получить ваучер, нужно рассказать друзьям о победе в торгах за этот лот.';
    //         var title = 'Поделитесь с друзьями!';
    //         swal({
    //                 title: title,
    //                 text: text,
    //                 type: "warning",
    //                 showCancelButton: true,
    //                 confirmButtonColor: "#2A8FBD",
    //                 confirmButtonText: "Рассказать друзьям",
    //                 cancelButtonText: "Отмена",
    //                 closeOnConfirm: true,
    //                 closeOnCancel: true,
    //                 allowHTML: true,
    //                 afterShow: function($dom) {
    //                     // setSocialButton($dom, postData);
    //                 }
    //             },
    //             function(isConfirm) {
    //                 if (isConfirm) socialPost(postData);
    //             });
    //         return false;
    //     });
    // }

    if ($('#tour-alert').length > 0) {
        var tour_id = $('#tour-alert').data('tour-id');

        $.post('/tourObject/hasAlert', {
            tour_id: tour_id
        }, function(data) {
            if (data.isBlitz) {
                //swal({
                //    allowHTML: true,
                //    title: "Поздравляем!",
                //    text: 'Вы купили лот по блиц-цене!<br>Для завершения сделки необходимо оплатить лот.<br>Вы можете это сделать в течение 4 часов из Личного кабинета или по ссылке из отправленного Вам эл.письма',
                //    type: "warning",
                //    showCancelButton: true,
                //    confirmButtonColor: "#227297",
                //    confirmButtonText: "Перейти к оплате",
                //    cancelButtonText: 'Закрыть',
                //    closeOnConfirm: true
                //  },
                //  function(isConfirm){
                //    if (isConfirm) {
                //      window.location.href = data.paymentLink;
                //    }
                //  }
                //);
            } else {
                swal({
                        html: true,
                        title: "Поздравляем!",
                        text: 'Вы выиграли торги за лот<br>"' + data.title + '"<br>Необходимо оплатить тур в течение 24 часов.<br>Оплатите из личного кабинета или по ссылке в письме.',
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#2A8FBD",
                        confirmButtonText: "Перейти к оплате",
                        cancelButtonText: 'Закрыть',
                        closeOnConfirm: true
                    },
                    function(isConfirm) {
                        if (isConfirm) {
                            window.location.href = data.paymentLink;
                        }
                    }
                );
            }
        }, 'json');
    }

    if (window.betSuccess) {
        showSuccessModal(window.betType);
    }

    if (window.permanentMakeBet) {
        $(".make-bet-form").trigger('submit');

    }

    if ($("#unsub_form").length) {
        var $form = $("#unsub_form");
        var check_count = $form.find('input[type=checkbox]:not(#un_all)').length;
        $form.find('input[type=checkbox]').on('ifChanged', function() {
            var $this = $(this);
            if ($this.attr('id') == 'un_all') {
                if ($this.is(':checked')) {
                    $form.find('input[type=checkbox]:not(#un_all)').prop('checked', false);
                } else {
                    $form.find('input[type=checkbox]:not(#un_all)').prop('checked', true);
                }
            } else {
                if ($this.is(':checked')) {
                    $("#un_all").prop('checked', false);
                } else {
                    var checked_count = $form.find('input[type=checkbox]:not(#un_all):checked').length;
                    if (checked_count == 0) {
                        $("#un_all").prop('checked', true);
                    }
                }
            }
            $form.find('input[type=checkbox]').iCheck('update');
        });
    }

    $('.datepicker').each(function() {
        if ($(this).is('.set-start-date')) {
            $(this).datepicker({
                format: 'dd.mm.yyyy',
                language: 'ru',
                startDate: new Date(),
                //disableTouchKeyboard: true,
                autoclose: true
            });
        } else {
            var startDateString = $(this).data('start-date');
            var endDateString = $(this).data('end-date');
            var startDate = null;
            var endDate = null;

            if (startDateString) {
                startDate = moment(startDateString, 'DD.MM.YYYY').toDate();
            }

            if (endDateString) {
                endDate = moment(endDateString, 'DD.MM.YYYY').toDate();
            }


            $(this).datepicker({
                format: 'dd.mm.yyyy',
                language: 'ru',
                startDate: startDate,
                endDate: endDate,
                //disableTouchKeyboard: true,
                autoclose: true
            });
        }
    });

    if (isMobileBrowser) {
        $('#search-begin').on('click', function() {
            $(this).blur();
        });

        $('#search-end').on('click', function() {
            $(this).blur();
        });
    }

    //$('#search-begin, #search-end').datepicker({
    //  format: 'dd.mm.yyyy',
    //  language: 'ru',
    //  startDate: new Date(),
    //  autoclose: true
    //}).on('changeDate', function() {
    //  var inputId = '#' + $(this).attr('id') + '-input';
    //  var date = $(this).datepicker('getFormattedDate');
    //  $(inputId).val(date);
    //  $(this).parents('form').trigger('change');
    //
    //  $(this).text(date);
    //});

    $('#search-guests').selectpicker({
        width: 'auto'
    });

    function normalizeDateInputs($begin, $end) {
        var start = $begin.datepicker('getDate');
        var minEnd = new Date(start.getTime() + 3600 * 24 * 1000);
        var end = $end.datepicker('getDate');
        if (start >= end) {
            $end.datepicker('setDate', minEnd);
        }
        $end.datepicker('setStartDate', minEnd);
    }

    $('#search-begin').on('changeDate', function() {
        normalizeDateInputs($(this), $('#search-end'));
    });

    var searchFormChangeBufferTimeout;
    var searchTooltipTimeout;

    $('#search-form').on('change', function() {
        $form = $(this);
        var $button = $form.find('button[type=submit]');
        clearTimeout(searchFormChangeBufferTimeout);
        searchFormChangeBufferTimeout = setTimeout(function() {
            $button.removeClass('hidden');

            $.ajax({
                url: $form.data('filterurl'),
                data: $form.serialize(),
                success: function(response) {
                    $button.tooltip('destroy');
                    var tooltipText = '';
                    var count = null;
                    if ($form.data('section') == 'bought') {
                        count = response.bought_count;
                    } else {
                        count = response.active_count;
                    }

                    if (count > 0) {
                        tooltipText = Text.plural(count, ['Найден', 'Найдено', 'Найдено']);

                        tooltipText += ' ' + count + ' ' + Text.plural(count, ['лот', 'лота', 'лотов']);
                        //$button.attr('disabled', false);
                    } else {
                        tooltipText = 'Ничего не найдено';
                        //$button.attr('disabled', true);
                    }

                    $button.tooltip({
                        trigger: 'manual',
                        html: true,
                        title: tooltipText,
                        placement: 'top'
                    }).tooltip('show');


                    clearTimeout(searchTooltipTimeout);
                    searchTooltipTimeout = setTimeout(function() {
                        $button.tooltip('destroy');
                    }, 5000);
                }
            });

        }, 400);
    });

    $('input:checkbox').on('ifChanged', function() {
        $(this).trigger('change');
    });


    $('.form-control-feedback').on('click', function() {
        $(this).prev().focus();
    });

    if (window.showAuthModal !== undefined) {
        $("#login_link").trigger('click');
    }

    $('#request-form').on('show.bs.collapse', function() {
        $('#request-form-toggle').hide();
    });


    $("#share-modal").on('show.share', function() {
        $('#share-modal .social-share-select .social-select:eq(1)').trigger('click');
    });

    $("#share-modal").on('hidden.share', function() {
        errorShare(0);
    });

    $('.social-share-select').on('click', '.social-select', function(e) {
        e.preventDefault();

        $(this).parents('.social-share-select').find('.social-select').each(function() {
            $(this).removeClass('active');
        });

        $(this).addClass('active');

        $('.post-preview-container').each(function() {
            if (!$(this).hasClass('hidden')) {
                $(this).addClass('hidden');
            }
        });
        var service = $(this).data('service');
        $('.post-preview-container.' + service).removeClass('hidden');

        if (service == 'email') {
            $('#share-modal').find('.btn-block').off('click').on('click', function(e) {
                e.preventDefault();
                $('#share-modal').find('.share-email-form').submit();

                return false;
            });

            return false;
        }

        var services = {
            fb: 'facebook',
            vk: 'vkontakte',
            tw: 'twitter',
            mm: 'mailru',
            ok: 'odnoklassniki'
        };

        // Генерируем пост
        setButtonLoading($("#share-modal .btn-block"), true);

        var postData = {
            id: 0,
            bet: 0,
            share_type: 'share_main',
            title: '',
            image: '',
            message: '',
            postID: null,
            description: '',
            success: function() {
                $("#follow-modal").modal('show');
                $("#share-modal").unbind('hidden.share');
                $("#share-modal").modal('hide');
                successShare(0);
            },
            error: function() {
                errorShare(0);
            }
        };

        $.ajax({
            url: '/tourObject/createUrl?json=true',
            type: 'post',
            data: {
                id: 0,
                bet: 0,
                share_type: 'share_main',
                service: services[service]
            },
            dataType: 'json',
            success: function(data) {
                setButtonLoading($("#share-modal .btn-block"), false);
                postData.postID = data.postID;
                postData.description = data.description;
                postData.title = data.title;
                postData.url = data.url;
                postData.image = data.image;
                postData.message = data.message;

                $('#share-modal .shareButton').remove();
                // setSocialButton($("#share-modal"), postData, services[service]);
                $("#share-modal .btn-block").unbind().click(function() {
                    socialPost(postData, services[service]);
                });
            },
            error: function(data) {
                $("#share-modal").modal('hide');
                alert('Что то пошло не так, повторите попытку чуть позже');
            }
        });

    });


    $('.tour-share-button').on('click', function(e) {
        e.preventDefault();
        var currentService = $(this).data('service'),
            $modal = $('#tour-share-modal');


        $modal.find('.post-preview-container').each(function() {
            if (!$(this).hasClass('hidden')) {
                $(this).addClass('hidden');
            }
        });

        var shared = false;
        $modal.find('.post-preview-container.' + currentService).removeClass('hidden');
        $modal.modal('show');

        $modal.unbind('hidden.share').on('hidden.share', function() {
            errorShare($form.data('id'));
        });

        var service = $(this).data('service');
        var $form = $(".make-bet-form");

        $('.post-preview.' + service).removeClass('hidden');
        var services = {
            fb: 'facebook',
            vk: 'vkontakte',
            tw: 'twitter',
            mm: 'mailru',
            ok: 'odnoklassniki'
        };

        if (currentService == 'email') {
            $modal.find('.btn-block').off('click').on('click', function(e) {
                e.preventDefault();
                $modal.find('.share-email-form').submit();

                return false;
            });

            return false;
        }

        // Генерируем пост
        setButtonLoading($("#tour-share-modal .btn-block"), true);

        var bet = parseInt($form.data('current-price'));
        var postData = {
            id: $form.data('id'),
            bet: bet,
            share_type: 'share_tour',
            title: $form.data('title'),
            image: $form.data('image'),
            message: '',
            postID: null,
            description: $form.data('description'),
            success: function() {
                setTimeout(function() {
                    $('.limit-button-js').removeClass('hidden');
                    $modal.unbind('hidden.share');
                    $modal.modal('hide');
                    $modal.trigger('social.share');
                    successShare($form.data('id'));
                    showFollowModal();
                }, 100);
            },
            error: function() {
                errorShare($form.data('id'));
            }
        };

        $.ajax({
            url: '/tourObject/createUrl?json=true',
            type: 'post',
            data: {
                id: $form.data('id'),
                bet: bet,
                share_type: 'share_tour',
                service: services[service]
            },
            dataType: 'json',
            success: function(data) {
                setButtonLoading($("#tour-share-modal .btn-block"), false);
                postData.postID = data.postID;
                postData.description = data.description;
                postData.title = data.title;
                postData.url = data.url;
                postData.message = data.message;
                postData.ok = data.ok;

                $('#tour-share-modal .shareButton').remove();
                // setSocialButton($("#tour-share-modal"), postData, services[service]);
                $("#tour-share-modal .btn-block").unbind().click(function() {
                    socialPost(postData, services[service]);
                });
            },
            error: function(data) {
                $('#tour-share-modal').modal('hide');
                alert('Что то пошло не так, повторите попытку чуть позже');
            }
        });

        return false;
    });

    $('.share-button').on('click', function(e) {
        e.preventDefault();
        $('#share-modal').modal('show');

        return false;
    });

    $('.share-email-form').on('submit', function(e) {
        e.preventDefault();
        $form = $(this);

        setButtonLoading($('.post-share-button'), true);

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),

            success: function(response) {
                setButtonLoading($('.post-share-button'), false);

                if (response.success == true) {
                    $form.parents('.modal').modal('hide');
                    showFollowModal();
                    $('.limit-button-js').removeClass('hidden');


                } else {
                    alert(response.error);
                }
            },

            error: function() {
                alert('Извините произошла ошибка');
                setButtonLoading($('.post-share-button'), false);
            }
        });
        return false;
    });

    if ($.cookie('reachgoal')) {
        reachGoal($.cookie('reachgoal'));
        $.cookie('reachgoal', true, {
            expires: -1,
            path: '/'
        });
    }

    $('#tour-sidebar').on('click', '.limit-button', function(e) {
        e.preventDefault();
        if ($(this).data('needpost') == true) {
            swal({
                title: 'Автоставка недоступна',
                text: 'Сначала нужно сделать как минимум одну ставку',
                type: 'error',
                confirmButtonColor: '#2A8FBD'
            });
        } else {
            showLimitModal();
        }
    });

    $('#limit-modal').find('.btn.btn-default input:radio:checked').parent().addClass('active');

    $('#limit-modal').on('click', '#limitSubmit', function(e) {
        e.preventDefault();

        cleanErrors($('#limit-modal'));

        var tourId = $('#tour-sidebar').data('tour-id');
        $.ajax({
            url: '/autoBet/create/?tour_id=' + tourId,
            data: $('.modal-limit-form').serialize(),
            type: 'post',
            dataType: 'json',
            success: function(data) {
                if (data.status == 'ok') {
                    $('.limit-button-js').replaceWith(data.limit_button);
                    $('#limit-modal').modal('hide');
                } else {
                    showErrors($('#limit-modal'), data.errors);
                }
            }
        });

        return false;
    });

    $('.subscribe-form').on('submit', function(e) {
        e.preventDefault();

        var $form = $(this);

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),

            success: function(response) {
                if (response.success == true) {
                    swal({
                        title: '',
                        text: 'Вы успешно подписались на рассылку',
                        type: 'success',
                        confirmButtonColor: '#2A8FBD'
                    });
                    $('#follow-modal').modal('hide');
                } else {
                    swal({
                        title: 'Что-то пошло не так',
                        text: 'Извините, произошла ошибка, попробуйте подписаться еще раз',
                        type: 'error',
                        confirmButtonColor: '#2A8FBD'
                    });
                }
            }
        });

        return false;
    });

    function successShare(tour_id) {
        $.ajax({
            url: '/share/success',
            data: {
                tour_id: tour_id
            },
            type: 'post'
        });
    }

    function errorShare(tour_id) {
        $.ajax({
            url: '/share/error',
            data: {
                tour_id: tour_id
            },
            type: 'post'
        });
    }

    $('#limit-modal').on('click', '.coming_soon', function(e) {
        if (!$(this).find(':checkbox').is(':checked')) {
            setTimeout(function() {
                swal({
                    title: "Внимание!",
                    text: 'Функционал ещё тестируется, но скоро появиться',
                    type: "info",
                    confirmButtonColor: "#2A8FBD",
                    confirmButtonText: "Ок",
                    closeOnConfirm: false
                });
            }, 300);
        }
    });

    $('.load-more-active-tours').on('click', function(e) {
        e.preventDefault();
        var $self = $(this);
        $.ajax({
            url: $self.attr('href'),
            success: function(response) {
                $('#active-tours').find('.tour-cards').append($(response.items).unwrap().html());
                if (!response.next_page_url) {
                    $self.remove();
                } else {
                    $self.attr('href', response.next_page_url);
                }
            }
        });

        return false;
    });

    $('.load-more-bought-tours').on('click', function(e) {
        e.preventDefault();
        var $self = $(this);

        $.ajax({
            url: $self.attr('href'),
            success: function(response) {
                $('#bought-tours').find('.tour-cards').append($(response.items).unwrap().html());
                if (!response.next_page_url) {
                    $self.remove();
                } else {
                    $self.attr('href', response.next_page_url);
                }
            }
        });

        return false;
    });

    $('.load-more-reviews').on('click', function(e) {
        e.preventDefault();
        var $self = $(this);

        $.ajax({
            url: $self.attr('href'),
            success: function(response) {
                $('.reviews-container').append($(response.reviews));
                if (!response.nextPageUrl) {
                    $self.remove();
                } else {
                    $self.attr('href', response.nextPageUrl);
                }
            }
        });

        return false;
    });

    $('.comment .expand').on('click', function(e) {
        e.preventDefault();
        $(this).parents('.comment-content').find('.expanded-content').toggleClass('hidden');
        $(this).parents('.comment-content').find('.short-content').toggleClass('hidden');

        var toggleText = $(this).data('toggletext');
        var text = $(this).text();

        $(this).data('toggletext', text);
        $(this).text(toggleText);

        return false;
    });

    function recalcDiscount() {
        var discount = 10;
        $('#bid-form input.reason:checked').each(function(index, item) {
            discount += parseInt($(item).data('discount'));
            var $child = $(item).parents('li').find('input.child-reason:checked');
            if ($child.length > 0) {
                discount += parseInt($child.data('discount'));
            }
        });

        $('#bid-form #discount-hidden-js').val(discount);
    }

    var validateDatesXHR = null;

    function ajaxValidateDates() {
        if (validateDatesXHR) {
            validateDatesXHR.abort();
        }

        $form = $('#bid-form');
        validateDatesXHR = $.ajax({
            type: 'post',
            url: $form.data('validate-url'),
            data: $form.serialize(),
            dataType: 'json',
            success: function(data) {
                $('.reason-error').html(data.errors);
                if (data.errors == "") {
                    recalcDiscount();
                }
            }
        });
    }

    function checkDates() {
        var begin = $('#bid-begin').val().length > 0;
        var end = $('#bid-end').val().length > 0;
        var duration = $('#duration').is(':checked');
        var weekdays = $('#Bid_reasons_weekdays').is(':checked');

        if (begin && end && (duration || weekdays)) {
            ajaxValidateDates();
        } else {
            $('.reason-error').html('');
            recalcDiscount();
        }
    }

    $('#bid-form .reason').on('ifChanged', function(e) {
        e.preventDefault();

        var $this = $(this);

        $this.parents('li').find('ul').toggleClass('hidden');

        checkDates();
        recalcDiscount();

        if ($this.not(':checked')) {
            $this.parents('li').find('ul ins').eq(0).click();
        }

        return false;
    });

    $('#bid-form .child-reason').on('ifChanged', function(e) {
        e.preventDefault();

        checkDates();

        return false;
    });

    $('#bid-begin').on('change', function() {
        normalizeDateInputs($(this), $('#bid-end'));
        checkDates();
    });

    $('#bid-end').on('change', function() {
        checkDates();
    });

    $('.bid-button').on('click', function(e) {
        e.preventDefault();

        setButtonLoading($(this), true);
        $(this).closest('form').trigger('submit');

        return false;
    });

    if (!isMobileBrowser) {
        $('#region-select').multiselect({
            //buttonClass: 'dashed',
            includeSelectAllOption: true,
            //buttonContainer: '<div class="region-select-container"></div>',
            //templates: {
            //button: '<a class="multiselect dropdown-toggle" data-toggle="dropdown" href="#"></a>',
            //filter: '<li class="multiselect-item filter"><div class="input-group input-group-sm"><input class="form-control multiselect-search" type="text"></div></li>',
            //filterClearBtn: '<span class="input-group-btn input-group-sm"><button class="btn btn-default multiselect-clear-filter" type="button"><i class="fa fa-times"></i></button></span>'
            //},
            allSelectedText: 'Любой',
            //nonSelectedText: 'Ничего не выбрано',
            selectAllText: 'Выбрать все',
            //enableFiltering: true,
            //filterPlaceholder: 'Поиск',
            maxHeight: 300,
            //enableCaseInsensitiveFiltering: true,
            buttonText: function(options, select) {
                if (options.length === 0) {
                    return 'Ничего не выбрано <b class="caret"></b>';
                } else if (options.length > 1) {
                    if (options.length == select.find('option').length) {
                        return 'Все <b class="caret"></b>'
                    } else {
                        return options.length + ' ' + Text.plural(options.length, ['регион', 'региона', 'регионов']) + ' <b class="caret"></b>';
                    }
                } else {
                    var labels = [];
                    options.each(function() {
                        if ($(this).attr('label') !== undefined) {
                            labels.push($(this).attr('label'));
                        } else {
                            labels.push($(this).html());
                        }
                    });
                    return labels.join(', ') + ' <b class="caret"></b>';
                }
            }
        });

        $('#rest-kind-select').multiselect({
            checkboxName: 'rest_kind[]',
            buttonClass: 'dashed',
            includeSelectAllOption: true,
            buttonContainer: '<div class="rest-kind-select-container"></div>',
            templates: {
                button: '<a class="multiselect dropdown-toggle" data-toggle="dropdown" href="#"></a>',
                filter: '<li class="multiselect-item filter"><div class="input-group input-group-sm"><input class="form-control multiselect-search" type="text"></div></li>',
                filterClearBtn: '<span class="input-group-btn input-group-sm"><button class="btn btn-default multiselect-clear-filter" type="button"><i class="fa fa-times"></i></button></span>'
            },
            allSelectedText: 'Любой',
            nonSelectedText: 'Ничего не выбрано',
            selectAllText: 'Выбрать все',
            //enableFiltering: true,
            //filterPlaceholder: 'Поиск',
            maxHeight: 300,
            //enableCaseInsensitiveFiltering: true,
            buttonText: function(options, select) {
                if (options.length === 0) {
                    return 'Ничего не выбрано';
                } else if (options.length > 1) {
                    if (options.length == select.find('option').length) {
                        return 'Любой'
                    } else {
                        return options.length + ' ' + Text.plural(options.length, ['тип', 'типа', 'типов']);
                    }
                } else {
                    var labels = [];
                    options.each(function() {
                        if ($(this).attr('label') !== undefined) {
                            labels.push($(this).attr('label'));
                        } else {
                            labels.push($(this).html());
                        }
                    });
                    return labels.join(', ') + ' ';
                }
            }
        });

        $('#tags-select').multiselect({
            checkboxName: 'tags[]',
            buttonClass: 'dashed',
            includeSelectAllOption: true,
            buttonContainer: '<div class="tags-select-container"></div>',
            templates: {
                button: '<a class="multiselect dropdown-toggle" data-toggle="dropdown" href="#"></a>',
                filter: '<li class="multiselect-item filter"><div class="input-group input-group-sm"><input class="form-control multiselect-search" type="text"></div></li>',
                filterClearBtn: '<span class="input-group-btn input-group-sm"><button class="btn btn-default multiselect-clear-filter" type="button"><i class="fa fa-times"></i></button></span>'
            },
            allSelectedText: 'Все',
            nonSelectedText: 'Ничего не выбрано',
            selectAllText: 'Выбрать все',
            //enableFiltering: true,
            //filterPlaceholder: 'Поиск',
            maxHeight: 300,
            //enableCaseInsensitiveFiltering: true,
            buttonText: function(options, select) {
                if (options.length === 0) {
                    return 'Ничего не выбрано';
                } else if (options.length > 1) {
                    if (options.length == select.find('option').length) {
                        return 'Все'
                    } else {
                        return options.length + ' ' + Text.plural(options.length, ['сервис', 'сервиса', 'сервисов']);
                    }
                } else {
                    var labels = [];
                    options.each(function() {
                        if ($(this).attr('label') !== undefined) {
                            labels.push($(this).attr('label'));
                        } else {
                            labels.push($(this).html());
                        }
                    });
                    return labels.join(', ') + ' ';
                }
            }
        });
    } else {
        $('#region-select, #rest-kind-select, #tags-select').removeClass('hidden');
    }


    var $citySelect = $('.city-select');
    if (!$.cookie('setRegion')) {
        $citySelect.find('.city-confirm').removeClass('hidden');

        $('body').on('click', function() {
            $citySelect.find('.city-confirm').addClass('hidden');
        });
    }

    $citySelect.on('click', '.select-another', function(e) {
        e.preventDefault();
        $citySelect.find('.city-confirm').addClass('hidden');
        $citySelect.find('.dropdown-toggle').trigger('click');

        return false;
    });

    $citySelect.on('click', '.confirm', function(e) {
        e.preventDefault();
        $citySelect.find('.city-confirm').addClass('hidden');
        $.cookie('setRegion', true, {
            expires: 365,
            path: '/'
        });
        $.cookie('region_id', $(this).data('region'), {
            expires: 365,
            path: '/'
        });
        return false;
    });

    $citySelect.on('click', '.dropdown-menu a', function() {
        $.cookie('setRegion', true, {
            expires: 365,
            path: '/'
        });
        return true;
    });

    $('.discounts').on('click', '.discount', function(e) {
        window.location = $(this).data('url');
    });

    $('.catalog-cards').on('click', '.catalog-card', function() {
        window.location = $(this).find('a:first').attr('href');
    });

    $('.offer-cards').on('click', '.offer-card', function() {
        window.location = $(this).find('a:first').attr('href');
    });

    $('.load-more-tour-objects').on('click', function(e) {
        e.preventDefault();
        var $self = $(this);
        $.ajax({
            url: $self.attr('href'),
            success: function(response) {
                $('#tour-objects').find('.catalog-cards').append($(response.items).unwrap().html());
                if (!response.next_page_url) {
                    $self.remove();
                } else {
                    $self.attr('href', response.next_page_url);
                }
            }
        });

        return false;
    });

    $('a.confirm-action').on('click', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');

        var content = $(this).data('content');
        if (!content) {
            content = 'Вы уверены?';
        }

        swal({
                title: content,
                text: '',
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#2A8FBD",
                confirmButtonText: 'Да',
                cancelButtonText: "Нет",
                closeOnConfirm: true,
                closeOnCancel: true,
                html: true
            },
            function(isConfirm) {
                if (isConfirm) {
                    window.location = url;
                }
            }
        );

        return false;
    });

    $('a.complaint-action').on('click', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');

        swal({
                title: 'Подтвердите, что отель не связывается с вами',
                text: '',
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#2A8FBD",
                confirmButtonText: 'Подтверждаю',
                cancelButtonText: "Отмена",
                closeOnConfirm: true,
                closeOnCancel: true,
                html: true
            },
            function(isConfirm) {
                if (isConfirm) {
                    window.location = url;
                }
            }
        );

        return false;
    });

    $('body').on('click', '.check-auth', function(e) {
        var isGuest = $('#isGuest').val();
        if (isGuest == 1) {
            $('#login_link').trigger('click');
            e.preventDefault();
        }
    });

    if (!$.cookie('vlnHide')) {
        $('.video-link-notification-container').removeClass('hidden');
    }

    $('.video-link-notification-container .close').on('click', function() {
        $.cookie('vlnHide', "1", {
            expires: 1000,
            path: '/'
        });
        $(this).parents('.video-link-notification-container').addClass('hidden');
    });

    $('#mass-media').owlCarousel();

    $('body').on('click', '[data-toggle=collapse]', function(e) {
        if ($(this).data('toggle-text')) {
            var toggleText = $(this).data('toggle-text');
            var newToggleText = $(this).text();

            $(this).data('toggle-text', newToggleText);
            $(this).text(toggleText);
        }
    });

    $('.nav-trigger').on('click', function(e) {
        e.stopPropagation();
        $('#mobile-navigation').addClass('open');
        $('body').addClass('pushed');
    });

    $('.global-wrap').on('click', function() {
        if ($('body').hasClass('pushed')) {
            $('#mobile-navigation').removeClass('open');
            $('body').removeClass('pushed');
        }
    });

    $(".video-container").fitVids();

    $('#mobile-region-select').on('change', function() {
        window.location = '/user/setRegion?region_id=' + $(this).val();
    });

    if ($('.star-rating').length > 0) {
        $('.star-rating > li').each(function() {
            var list = $(this).parent(),
                listItems = list.children(),
                itemIndex = $(this).index();

            $(this).hover(function() {
                for (var i = 0; i < listItems.length; i++) {
                    if (i <= itemIndex) {
                        $(listItems[i]).addClass('hovered');
                    } else {
                        break;
                    }
                };
            }, function() {
                listItems.removeClass('hovered');
            });

            $(this).click(function() {
                for (var i = 0; i < listItems.length; i++) {
                    if (i <= itemIndex) {
                        $(listItems[i]).addClass('selected');
                    } else {
                        $(listItems[i]).removeClass('selected');
                    }
                };

                $(this).parents('.form-group').find('input[type=hidden]').val($(this).data('rating'));
            });
        });
    }

    if ($('.review-form').length > 0) {
        $('.review-form').on('submit', function(e) {
            var reviewRating = $(this).find('.rating-input').val();
            var reviewBody = $(this).find('.body-input').val();
            var reviewTitle = $(this).find('#review-title').val();
            var reviewType = $(this).find('input:radio:checked').length;

            if (!reviewRating || !reviewBody || !reviewTitle || !reviewType || reviewBody.length < 250) {
                e.preventDefault();
                var message = 'Заполните поля "отзыв" и "оценка туробъекту"';

                if (!reviewType) {
                    message = 'Укажите тип отдыха';
                }

                if (!reviewBody) {
                    message = 'Заполните поле "отзыв"';
                }else if (reviewBody.length < 250){
                    message = 'Поле "отзыв" должно содержать не менее 250 символов';
                }

                if (!reviewTitle) {
                    message = 'Заполните поле "Заголовок отзыва"';
                }

                if (!reviewRating) {
                    message = 'Укажите оценку туробъекту';
                }

                alert(message);
                return false;
            } else {
                var submitButton = $(this).find('button:submit');
                submitButton.attr('disabled', 'disabled');
                submitButton.css({color: 'white'});
            }
        });
    }

    $('#no-social-account-modal').one('show.bs.modal', function() {
        reachGoal('sn_not_B');
    });

    $('#login-modal').one('show.bs.modal', function() {
        var goal = $(this).data('goal');
        reachGoal(goal);
    });

    $('.reach-goal').on('click', function(e) {
        var goal = $(this).data('goal');
        if (goal) {
            reachGoal(goal);
        }
    });

    $('.mark-notification-as-read').on('click', function(e) {
        e.preventDefault();
        var $button = $(this);
        var href = $button.attr('href');

        $button
            .removeClass('fa-check')
            .addClass('fa-spinner')
            .addClass('fa-spin');

        $.ajax({
            url: href,
            success: function(response) {
                if (response.success) {
                    $button
                        .removeClass('fa-spinner')
                        .removeClass('fa-spin')
                        .addClass('fa-check')
                        .addClass('hidden');

                    var $row = $button.parents('tr');
                    $row
                        .removeClass('warning')
                        .find('.label.label-success')
                        .remove();
                }
            }
        });

        return false;
    });

    $('.notification-table').on('click', 'tr', function(e) {
        e.preventDefault();

        var href = $(this).data('url');
        var $readButton = $(this).find('.mark-notification-as-read');

        if ($readButton.length > 0) {
            $readButton.trigger('click');
        }
        window.location = href;

        return false;
    });

    if ($('.copy-refer-link').length > 0) {
        var clipboard = new Clipboard('.copy-refer-link');


        clipboard.on('success', function(e) {
            swal({
                title: 'Ссылка скопирована!',
                text: 'Теперь можешь поделиться ей с друзьями',
                html: true,
                type: "success",
                confirmButtonColor: "#2A8FBD",
                confirmButtonText: "Ок",
                closeOnConfirm: true
            });
        });

        clipboard.on('error', function(e) {
            var $target = $($(e.trigger).attr('data-clipboard-target'));
            var actionMsg = '';
            var actionKey = (e.action === 'cut' ? 'X' : 'C');

            if (/iPhone|iPad/i.test(navigator.userAgent)) {
                actionMsg = 'Не поддерживается =/';

                var input = $('.refer-link')[0];
                input.focus();
                input.setSelectionRange(0, 9999);
                return;
            } else if (/Mac/i.test(navigator.userAgent)) {
                actionMsg = 'Нажми ⌘-' + actionKey + ', чтобы скопировать';
            } else {
                actionMsg = 'Нажми Ctrl-' + actionKey + ', чтобы скопировать';
            }

            $target.tooltip({
                title: actionMsg,
                trigger: 'manual',
                placement: 'top'
            }).tooltip('show');

            setTimeout(function() {
                $target.tooltip('destroy');
            }, 3000);
        });
    }

    $('.btn-refer').on('click', function() {
        var date = $(this).data('date');
        var userId = $(this).data('user');

        var container = $(this).attr('href');
        $.get('/user/referralDateDetail', {
            date: date,
            user_id: userId
        }, function(html) {
            $(container).html(html);
        });
    });

    $('form.make-bet-form').on('click', '.travelPayoutsLead', function() {
        $.get('https://c39.travelpayouts.com/pixel.png?type=engaged');
    });

    $('#user-balance-modal').on('show.bs.modal', function() {
        var currentPrice = $('#bet_amount').val();
        var minCharge = currentPrice / 10;

        if (minCharge < 100) {
            minCharge = 100;
        }
        $(this).find('#сhargeAmount').val(minCharge);
    });

    $('#user-balance-modal #chargeButton').on('click', function(e) {
        e.preventDefault();

        $(this).parents('#user-balance-modal').find('#personal_account_form form').submit();
    });

    if($('#no-friends-global-modal').length > 0) {
        $('#no-friends-global-modal').modal('show');
    }

    if ($.cookie('friendsCountNotify')) {
        var $friendsCountNotifyModal = $('#friends-count-notify-modal');
        $friendsCountNotifyModal.modal('show');

        $friendsCountNotifyModal.on('click', '.more-link', function () {
            $.removeCookie('friendsCountNotify', { path: '/' });
        });

        $friendsCountNotifyModal.on('hidden', function () {
            $.removeCookie('friendsCountNotify', { path: '/' });

            if ($.cookie('autoMakeBid')) {
              $.removeCookie('autoMakeBid', { path: '/' });
//                $('#make-bet-button').trigger('click');
              beginMakeBet();
            }
        });
    }

    $('#login-modal').one('show', function () {
        reachGoal('zapr_reg');
    });

    if (window.userJustLogin) {
        reachGoal('ok_reg');
    }

    if ($('.photo-slider').length > 0) {
        $('.photo-slider').owlCarousel({
            singleItem: true
        });
    }

});
